import React from "react";
import { Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import TrendingViewChart from "../tradingview_chart/TradingViewChart";
import Footer from "../common/Footer";
import Navbar from "../common/NavBar";
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <div className="site-header header-s1 is-sticky">
        <Navbar />
        {/* Banner/Slider */}
        <div id="header" className="slider index-3">
          <Carousel
            showArrows={true}
            showThumbs={false}
            showStatus={false}
            infiniteLoop={true}
            autoPlay={false}
            transitionTime={1}
          >
            <div>
              <div
                className="single-slide light row-vm"
                style={{
                  backgroundImage: `url(${require("../../assets/images/header-bg-a.jpeg")})`, 
                }}
              >
                <div className="container">
                  <div className="banner-content">
                    <div className="row">
                      <div className="col-md-6 slider-text">
                        <div class="gaps size-2x"></div>
                        <h1 style={{ color: "black !important" }} className="animate-bottom delayms5">
                          Forex | Shares | Bonds | Digital Currencies
                        </h1>
                        <ul className="btns animate-bottom delayms9">
                          <li>
                            <Link to="#" className="btn">
                              Start Trading
                            </Link>
                          </li>
                        </ul>
                        <div class="gaps size-2x"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
        {/* End Banner/Slider */}
      </div>
      <div className="btc-ticker">
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="usd"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="eur"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="jpy"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="gbp"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="chf"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="aud"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="cad"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="nzd"></div>
        </div>
        <div className="ticker-item">
          <div className="btcwdgt-price" bw-cur="nzd"></div>
        </div>
      </div>
      {/* End BTC Ticker */}

      {/* Features Box */}
      <div className="features-box section section-pad currency-section">
        <div className="container">
          <div className="row text-center currency-widget">
            <div className="col-md-3 col-sm-6 res-m-bttm">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/coin-i.png")}
                  alt="box-icon"
                  className="box-icon coin"
                />
                <h6 className="ucap">EUR/USD</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 res-m-bttm">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/coin-k.png")}
                  alt="box-icon"
                  className="box-icon coin"
                />
                <h6 className="ucap">GBP/USD</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 res-m-bttm">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/coin-j.png")}
                  alt="box-icon"
                  className="box-icon coin"
                />
                <h6 className="ucap">USD/JPY</h6>
              </div>
            </div>
          </div>
          <h2 className="text-center">
            Our Major Currency Pairs
          </h2>
        </div>
      </div>
      {/*End Features Box */}

      {/* Features Box */}
      <div style={{ paddingTop: '40px' }} className="features-box section section-pad">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 col-sm-6 res-m-bttm">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/box-icon-a.png")}
                  alt="box-icon"
                  className="box-icon"
                />
                <h6 className="ucap">Upto 1:2000<br /> Leverage</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 res-m-bttm">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/box-icon-b.png")}
                  alt="box-icon"
                  className="box-icon"
                />
                <h6 className="ucap">100+ Trading Instruments</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 res-m-bttm">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/box-icon-c.png")}
                  alt="box-icon"
                  className="box-icon"
                />
                <h6 className="ucap">24/7 Live Trading market</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="box box-alt-bg round shadow">
                <img
                  src={require("../../assets/images/box-icon-d.png")}
                  alt="box-icon"
                  className="box-icon"
                />
                <h6 className="ucap">Over 40 Global awards</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Features Box */}

      {/*Section */}
      <div className="section section-pad bg-grey">
        <div className="container">
          <div className="row row-vm">
            <div className="col-md-5">
              <div className="round mgr--30 res-m-bttm">
                <img
                  src={require("../../assets/images/photo-md-a.jpg")}
                  alt="photo-md"
                  className="img-shadow"
                />
              </div>
            </div>
            <div className="col-md-6 col-md-offset-1 ">
              <div className="text-block text-left">
                <h2>Tighter spreads,Faster execution</h2>
                <ul>
                  <li>Trade with modest spreads starting at 0.0 pips.</li>
                  <li>
                    24 hours a day, 5 days a week, the world's best liquidity
                    and market-leading prices.
                  </li>
                  <li>There will be no dealing desk and no re-quotes.</li>
                  <li>Forex Trading Education at AFC Trades.</li>
                </ul>

                <Link to="#" className="btn btn-alt">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Section */}

      {/*Section */}
      <div className="section section-pad bg-grey">
        <div className="container">
          <div className="row row-vm">
            <div className="col-md-6 col-md-offset-0 ">
              <div className="text-block text-left">
                <h2>Learn & trade what you want, when you want.</h2>
                <ul>
                  <li>Invest in Forex, Indexes, Stocks and Commodities.</li>
                  <li>Navigate global markets 7 days a week, 24 hours a day.</li>
                  <li>Invest on the move with our mobile applications, which are available 24/7.</li>
                  <li>Customer service in multiple languages available.</li>
                </ul>

                <Link to="#" className="btn btn-alt">
                  Read More
                </Link>
              </div>
            </div>
            <div className="col-md-5">
              <div className="round mgr--30 res-m-bttm">
                <img
                  src={require("../../assets/images/service-thumb-dd.jpg")}
                  alt="photo-md"
                  className="img-shadow"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      {/*End Section */}

      {/*Section */}
      <div className="section section-pad">
        <div className="container">
          <div className="section-head">
            <div className="row text-center">
              <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                <h2 className="heading-section">Why choose Us</h2>
                <p>
                  Highly competitive market conditions such as low trading fees
                  starting from 0.0 spreads and a maximum leverage of 1:500.
                </p>
              </div>
            </div>
          </div>
          <div className="gaps size-3x"></div>
          <div className="row text-center row-vm">
            <div className="col-md-4 res-m-bttm-lg">
              <div className="box-alt">
                <span className="pe pe-7s-server"></span>
                <h4>Payment Options</h4>
                <p>
                  Enjoy multiple payment methods tailored for convenience and
                  flexibility.
                </p>
              </div>
              <div className="box-alt">
                <span className="pe pe-7s-note"></span>
                <h4>Legal Compliance</h4>
                <p>
                  Trade with confidence, knowing we adhere to strict legal and
                  regulatory standards.
                </p>
              </div>
              <div className="box-alt">
                <span className="pe pe-7s-airplay"></span>
                <h4>Cross-Platform Trading</h4>
                <p>
                  Access our platform on any device, anytime, for seamless
                  trading experiences.
                </p>
              </div>
            </div>
            <div className="col-md-4 res-m-bttm-lg">
              <div className="box-alt">
                <span className="pe pe-7s-lock"></span>
                <h4>Strong Security</h4>
                <p>
                  Your assets and data are protected with advanced encryption
                  and security protocols.
                </p>
              </div>
              <div className="box-alt img">
                <img
                  src={require("../../assets/images/square-eu-b.png")}
                  alt="square"
                />
              </div>
              <div className="box-alt">
                <span className="pe pe-7s-cash"></span>
                <h4>Competitive Commissions</h4>
                <p>
                  Benefit from low trading fees designed to maximize your
                  profitability.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box-alt">
                <span className="pe pe-7s-global"></span>
                <h4>World Coverage</h4>
                <p>
                  Trade globally with support in multiple countries and
                  currencies.
                </p>
              </div>
              <div className="box-alt">
                <span className="pe pe-7s-graph"></span>
                <h4>Advanced Reporting</h4>
                <p>
                  Analyze your performance with detailed reports and insights at
                  your fingertips.
                </p>
              </div>
              <div className="box-alt">
                <span className="pe pe-7s-graph1"></span>
                <h4>Margin Trading</h4>
                <p>
                  Amplify your trading potential with customizable margin
                  options and tools.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Section */}

      {/*Section */}
      {/* <div className="section section-pad bg-grey">
        <div className="container">
          <div className="row row-vm">
            <div className="col-md-6">
              <div className="trendingview-chart res-m-bttm">
                <TrendingViewChart />
              </div>
            </div>
            <div className="col-md-5 col-md-offset-1">
              <div className="text-block text-left">
                <h2>Why is AFC Traders regarded as a top global broker?</h2>
                <ul>
                  <li>Internationally regulated and supervised.</li>
                  <li>Over 40 global awards.</li>
                  <li>24/7 multilingual customer care.</li>
                  <li>Consistently Stricter Spreads</li>
                  <li>5+ Years of Stock Trading experience</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div id="converter-container" className="col-md-12"></div>
          </div>
        </div>
      </div> */}
      {/*End Section */}

      {/*Section */}
      {/* <div className="section section-pad">
        <div className="container">
          <div className="section-head">
            <div className="row text-center">
              <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                <h2 className="heading-section">What Investors Say</h2>
                <p>
                  Hear from our satisfied investors about their journey and
                  experiences with us.
                </p>
              </div>
            </div>
          </div>
          <div className="gaps size-3x"></div>
          <div className="row text-center">
            <div className="col-md-6 col-md-offset-3">
              <div
                className="testimonial-carousel has-carousel"
                data-items="1"
                data-loop="true"
                data-dots="true"
                data-auto="true"
              >
                <div className="testimonial-item">
                  <div className="client-photo circle">
                    <img
                      src={require("../../assets/images/client-a.jpg")}
                      alt="client"
                    />
                    <em className="fa fa-quote-right"></em>
                  </div>
                  <blockquote>
                    "The platform's ease of use and excellent support have been
                    game-changers for my investments. Highly recommended!"
                  </blockquote>
                  <div className="client-info">
                    <h6>Jane Smith</h6>
                    <span>Investor</span>
                  </div>
                </div>
                <div className="testimonial-item">
                  <div className="client-photo circle">
                    <img
                      src={require("../../assets/images/client-b.jpg")}
                      alt="client"
                    />
                    <em className="fa fa-quote-right"></em>
                  </div>
                  <blockquote>
                    "Thanks to this platform, I’ve been able to achieve
                    financial freedom through smart investments in
                    cryptocurrency."
                  </blockquote>
                  <div className="client-info">
                    <h6>Michael Lee</h6>
                    <span>Entrepreneur</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/*End Section */}

      {/* Section */}
      <div className="section section-pad-sm cta-small light">
        <div className="cta-block">
          <div className="container">
            <div className="row mobile-center">
              <div className="col-md-12">
                <div className="cta-sameline">
                  <h3>Open account for free and start trading Forex now!</h3>
                  <Link className="btn btn-outline btn-alt btn-md" to="#">
                    get started
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Section */}

      {/*Section */}
      {/* <div className="section section-pad">
        <div className="container">
          <div className="section-head">
            <div className="row text-center">
              <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                <h2 className="heading-section">our latest news</h2>
                <p>
                  Stay updated with the newest trends, insights, and updates
                  from the world of Forex Trading and blockchain technology.
                </p>
              </div>
            </div>
          </div>
          <div className="gaps size-3x"></div>
          <div className="row text-center">
            <div className="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 res-m-bttm-lg">
              <div className="blog-post shadow round">
                <div className="post-thumb">
                  <Link to="/about">
                    <img
                      src={require("../../assets/images/post-thumb-a.jpg")}
                      alt="post"
                    />
                  </Link>
                </div>
                <div className="post-entry">
                  <div className="post-meta">
                    <span>Posted 03 Dec, 2023</span>
                  </div>
                  <h5>
                    <Link to="/about">
                      Meeting the High Demand for Forex Trading
                    </Link>
                  </h5>
                  <p>
                    Discover how we're scaling our platform to meet the growing
                    demand and provide seamless experiences for our users.
                  </p>
                  <Link to="/about" className="btn-icon">
                    <span className="pe pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 res-m-bttm-lg">
              <div className="blog-post shadow round">
                <div className="post-thumb">
                  <Link to="/about">
                    <img
                      src={require("../../assets/images/post-thumb-b.jpg")}
                      alt="post"
                    />
                  </Link>
                </div>
                <div className="post-entry">
                  <div className="post-meta">
                    <span>Posted 27 Nov, 2023</span>
                  </div>
                  <h5>
                    <Link to="/about">
                      Black Friday Deals: Crypto Opportunities Await
                    </Link>
                  </h5>
                  <p>
                    Take advantage of exclusive Black Friday offers and deals to
                    maximize your Forex investments today!
                  </p>
                  <Link to="/about" className="btn-icon">
                    <span className="pe pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 res-m-bttm-lg">
              <div className="blog-post shadow round">
                <div className="post-thumb">
                  <Link to="/about">
                    <img
                      src={require("../../assets/images/post-thumb-c.jpg")}
                      alt="post"
                    />
                  </Link>
                </div>
                <div className="post-entry">
                  <div className="post-meta">
                    <span>Posted 15 Nov, 2023</span>
                  </div>
                  <h5>
                    <Link to="/about">
                      Introducing Our New Payment Services
                    </Link>
                  </h5>
                  <p>
                    We’re excited to unveil faster and more secure payment
                    solutions, designed to enhance your trading experience.
                  </p>
                  <Link to="/about" className="btn-icon">
                    <span className="pe pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/*End Section */}
      <Footer />
    </>
  );
};

export default Home;
